import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'AddPaymentForm' | 'EditPaymentForm' | 'RemoveCardModal';

/**
 * Errors related to the Credit Cards page
 */
export const Errors = createErrors<Page, Component>('CreditCards')({
    AddPaymentForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to add credit card',
        },
    },
    EditPaymentForm: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to edit credit card',
        },
    },
    RemoveCardModal: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to remove credit card',
        },
    },
});
